import { format as dateFormat, formatDistanceToNow, formatISO } from "date-fns"

import currentLocale from "./currentLocale"

// At this time, all locales are expected to apply the 'house style'
// for time formats which is (for now, until the backlash arrives)
// an American style of date and time.
const FORMATS = {
  tc_date: "MMMM d, yyyy", // September 29, 2014
  tc_short_month_date: "MMM d, yyyy", // Sep 29, 2014
  tc_date_with_time: "MMMM d, yyyy h.mma", // September 29, 2014 9.45am
  tc_time: "h.mma", // 9.45am
}

export default class TimeFormatter {
  /**
   * Formats the given date/time
   * @param {undefined, null, string, Date} time can be null, undefined an ISO 8601 string or a `Date` object
   * @param {string} format. Example: "tc_date_with_time"
   * @return {string}
   * @throws RangeError
   */
  static formatted(time, format = "tc_date_with_time") {
    const currentFormat = FORMATS[format]
    const timeParam = time === null || time === undefined ? new Date() : new Date(time)

    if (currentFormat === undefined) {
      return formatISO(timeParam)
    }

    return dateFormat(timeParam, currentFormat, { locale: currentLocale.dateFnsLocale() })
  }

  /**
   * Return the distance between the given date and now in words, localized.
   * @param {Date} dateTime
   * @param {Boolean} suffix. Adds suffix to the relative time, e.g.: "1 year ago"
   */
  static fromNow(dateTime, suffix = true) {
    return formatDistanceToNow(dateTime, {
      addSuffix: suffix,
      locale: currentLocale.dateFnsLocale(),
    })
  }
}
